import { loadBing } from "src/vendor/bing";
import { registerHandler } from "../handler";
import { trackTask } from "src/utils/monitoring/events/tasks";

export default function registerHandlers() {
  registerHandler("lead", () => {
    loadBing().then((bing) => {
      const task = trackTask("trackBingLead");
      try {
        task.start();
        bing.push({
          ec: "Lead",
          ea: "Lead",
          el: "Lead",
          ev: "0",
        });
        task.success();
      } catch (err) {
        task.failed(err);
      }
    });
  });

  registerHandler("purchase", ({ order }) => {
    loadBing().then((bing) => {
      const task = trackTask("trackBingPurchase");
      try {
        task.start();
        bing.push({
          ec: "Purchase",
          ea: "Purchase",
          el: "Purchase",
          ev: "0",
          gv: order.eltv_13_months.toFixed(3),
          gc: "USD",
        });
        task.success();
      } catch (err) {
        task.failed(err);
      }
    });
  });

  registerHandler("purchaseIntent", ({ estimatedValue }) => {
    loadBing().then((bing) => {
      const task = trackTask("trackBingPurchaseIntent");
      try {
        task.start();
        bing.push({
          ec: "med_purchase",
          ea: "med_purchase",
          el: "med_purchase",
          ev: "0",
          gv: estimatedValue.toFixed(3),
          gc: "USD",
        });
        task.success();
      } catch (err) {
        task.failed(err);
      }
    });
  });
}
